<template>
  <div class="setRules">
    <div class="title">设定依据</div>
    <a-collapse default-active-key="1" :bordered="false">
      <template #expandIcon="props">
        <a-icon style="color:#999" :component="IconCaretRight" :rotate="props.isActive ? 90 : 0" />
      </template>
      <a-collapse-panel :key="index" :style="customStyle" v-for="(item,index) in basisInfo">
        <template slot="header">
          <div style="background:#fff;overflow:hidden;display: flex;justify-content: space-between;">
            <div style="color: #333333;font-weight:bold;flex: 5;margin-right: 10px;" @click="handleJump(item.originalAddress)">
              《{{ item.legalName }}》
            </div>
            <div style="display: flex; flex: 5;justify-content: space-between;">
              <div style="font-size:14px;color: #999999;">{{ item.enactingAuthority }}</div>
              <span style="font-size:14px;color: #999999;" v-if="item.implementationDate">{{ item.implementationDate | dateTransfer }} 起实施</span>
            </div>
          </div>
        </template>
        <div style="padding:12px;padding-bottom:8px">{{ item.legalContent }}</div>
      </a-collapse-panel>
      <!-- <a-collapse-panel key="2" :style="customStyle">
        <template slot="header">
          <div style="background:#fff;overflow:hidden">
            <span style="float:left;color: #333333;font-weight:bold">
              《中华人民共和国城市房地产管理法》
            </span>
            <div style="float:right">
              <span style="font-size:14px;color: #999999;margin-right:20px">全国人大常委会</span>
              <span style="font-size:14px;color: #999999;">1995-01-01起实施</span>
            </div>
          </div>
        </template>
        <div style="padding:12px;padding-bottom:8px">第五十四条 房屋租赁，出租人和承租人应当签订书面租赁合同，约定租赁期限、租赁用途、租赁价格、修缮责任等条款，以及双方的其他权利和义务，并向房产管理部门登记备案。</div>
      </a-collapse-panel>
      <a-collapse-panel key="3" :style="customStyle">
        <template slot="header">
          <div style="background:#fff;overflow:hidden">
            <span style="float:left;color: #333333;font-weight:bold">
              《中华人民共和国城市房地产管理法》
            </span>
            <div style="float:right">
              <span style="font-size:14px;color: #999999;margin-right:20px">全国人大常委会</span>
              <span style="font-size:14px;color: #999999;">1995-01-01起实施</span>
            </div>
          </div>
        </template>
        <div style="padding:12px;padding-bottom:8px">第五十四条 房屋租赁，出租人和承租人应当签订书面租赁合同，约定租赁期限、租赁用途、租赁价格、修缮责任等条款，以及双方的其他权利和义务，并向房产管理部门登记备案。</div>
      </a-collapse-panel> -->
    </a-collapse>
  </div>
</template>

<script>
import IconCaretRight from '@ant-design/icons/svg/outline/caret-right.svg?inline'
import { dateTransfer } from '@/utils/timeUtil'
export default {
  props: {
    basisInfo: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: () => []
    }
  },
  filters: {
    // 格式化时间
    dateTransfer
  },
  data () {
    return {
      IconCaretRight,
      customStyle: 'border: 0'
    }
  },
  methods: {
    handleJump (url) {
      url && window.open(url, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  background: #fff;
}
.setRules {
  .title {
    font-size: 22px;
    color: #333333;
    margin-bottom:5px;
    font-weight: 500;
  }
}
</style>
